<template>
  <div class="checkout-plan-box" id="checkout-planos-cta-confirmar">
    <div>
      <span class="checkout-plan-box__offer" v-if="plan.tag && plan.tag.text">{{ plan.tag.text }}</span>
      <div
        @click="() => $emit('click')"
        :id="plan.sku"
        :class="{
          'checkout-plan-box__card': true,
          'checkout-plan-box__card--selected': (selected.sku === plan.sku),
          'checkout-plan-box__card--offer': (plan.card.header)
        }"
      >
         <div v-if="plan.sticker" class='checkout-plan-box__card__sticker'>
            <figure>
            <img
              :alt="plan.card.text"
              :src="plan.sticker"
              />
            </figure>
          </div>
        <a class="checkout-plan-box__card__radio"></a>
        <div class="checkout-plan-box__card__description">
          <h1 v-html="plan.card.title"></h1>
        </div>
        <div class="checkout-plan-box__card__price">
          <span v-html="plan.card.text"></span>
        </div>
      </div>
      <p class="checkout-plan-box__legend" v-if="plan.card.footer" v-html="plan.card.footer"></p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'checkout-plan-box',
  props: {
    selected: Object,
    plan: Object
  }
}
</script>

<style lang="scss" scoped>
.checkout-plan-box {
  position: relative;
  max-width: 80%;
  margin: 0 auto 6rem auto;

  &__offer {
    position: absolute;
    top: -20px;
    left: 12px;
    width: calc(100% - 24px);
    color: #fff;
    background-color: #4C91FF;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    text-align: center;
    padding-top: 4px;
    padding-bottom: 4px;
    font-size: 1rem;
    line-height: 12px;
    text-transform: uppercase;
    font-weight: bold;
  }

  &__card {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: #FFFFFF;
    border-radius: 16px;
    box-shadow: 0px 4px 18px rgba(0, 0, 0, 0.1);
    box-sizing: border-box;
    min-width: 160px;

    &__sticker {
      position: absolute;
      width: 100%;
      text-align: center;

      figure {
        margin-top: 0;
      }
    }

    &__radio {
      position: absolute;
      top: 1rem;
      right: 1rem;
      width: 2rem;
      height: 2rem;
      border: 4px solid #A217AB;
      border-radius: 50%;
    }

    &__description {
      min-height: 180px;
      display: flex;
      align-items: center;
      h1 {
        text-align: center;
        font-family: Nunito;
        font-style: normal;
        font-weight: 900;
        font-size: 4rem;
        color: #A217AB;
      }
    }

    &__price {
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
      bottom: 0;
      width: 100%;
      height: 80px;
      border-bottom-left-radius: 16px;
      border-bottom-right-radius: 16px;
      background-color: #F3F7FA;

      span {
        font-family: Nunito;
        font-style: normal;
        font-weight: bold;
        font-size: 14px;
        line-height: 24px;
        color: #454545;
      }
    }

    &--offer {
      .checkout-plan-box__card__price {
        span {
          font-size: 20px;
          line-height: 24px;
          font-weight: 900;
          color: #A217AB;
        }
      }
    }

    &:hover {
      border: 3px solid #A217AB;
      box-sizing: border-box;
    }

    &--selected {
      border: 2px solid #6253BC;
      background-color: #6253BC;
      &:hover {
        border: 2px solid #6253BC;
      }

      .checkout-plan-box__card__radio {
        border: 4px solid #FFFFFF;
        display: flex;
        justify-content: center;
        align-items: center;
        &::after {
          display: block;
          content: '';
          border-radius: 50%;
          background: #FFFFFF;
          width: 12px;
          height: 12px;
        }
      }
      .checkout-plan-box__card__description>h1 {
        color: #FFFFFF;
      }
    }
  }

  &__legend {
    font-family: Nunito;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 16px;
    text-align: center;
  }

  .checkout-plan-box__card--selected.checkout-plan-box__card--offer {
    .checkout-plan-box__card__price {
      span {
        color: #6253BC;
      }
    }
  }
}
@media screen and (min-width: 641px) {
  .checkout-plan-box {
    min-width: 320px;
    max-width: 320px;

    &__offer {
      top: -30px;
      left: 20px;
      width: calc(100% - 40px);
      font-size: 14px;
      line-height: 20px;
      padding-top: 6px;
      padding-bottom: 6px;
    }
    &__card {
      &__description {
        h1 {
          font-size: 48.81px;
        }
      }

      &__price {
        height: 128px;
        span {
          font-size: 19.2px;
          line-height: 32px;
        }
      }

      &--offer {
        .checkout-plan-box__card__price {
          span {
            font-size: 27.65px;
            line-height: 40px;
          }
        }
      }
    }
    &__legend {
      font-size: 16px;
      line-height: 24px;
    }
  }
}
</style>
